import { render } from "./theme25.vue?vue&type=template&id=3fb109a1&scoped=true"
import script from "./theme25.vue?vue&type=script&lang=js"
export * from "./theme25.vue?vue&type=script&lang=js"

import "./theme25.vue?vue&type=style&index=0&id=3fb109a1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3fb109a1"

export default script